import React from 'react'

export const NoSustainabilityInitiativesIcon = (): JSX.Element => (
  <svg
    width="68"
    height="58"
    viewBox="0 0 68 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.159 58H10.3153C3.9604 51.866 0.00805664 43.2591 0.00805664 33.7291C0.00805664 15.1011 15.1091 0 33.7372 0C52.3653 0 67.4663 15.1011 67.4663 33.7291C67.4663 43.2591 63.514 51.866 57.159 58Z"
      fill="#F7E9E8"
    />
    <path
      d="M34.9101 51.0287C32.1933 46.5176 27.6668 35.9115 31.2962 29.5756C35.8328 21.6556 40.2157 21.8863 47.8281 23.6548C51.7995 24.5775 53.3925 24.918 53.878 25.0007C53.8863 24.9878 53.8945 24.9749 53.9026 24.962C54.081 25.0155 54.1371 25.0448 53.878 25.0007C50.2221 30.7465 41.1161 40.3236 32.8917 31.0558C31.2962 33.3049 30.9117 40.6481 36.7555 49.7984C37.4322 50.7826 37.8577 51.4388 37.9858 51.6438L34.9101 51.0287Z"
      fill="#4F987B"
    />
    <path
      d="M46.375 28.5C41.825 30.65 35.5625 30.3542 33 29.9375C40.35 37.5375 48.3958 30.5625 51.5 26.125C51.6875 26.0209 50.925 26.35 46.375 28.5Z"
      fill="#187759"
    />
    <path
      d="M20.3004 27.115C28.3587 24.4699 30.8347 30.0113 31.0654 33.1126C23.0685 39.2025 16.5583 33.1895 14.3027 29.4218C14.6359 29.268 16.3019 28.5913 20.3004 27.115Z"
      fill="#4F987B"
    />
    <path
      d="M10.8193 57.9999C18.5984 50.8377 38.454 40.8105 55.6433 57.9999H10.8193Z"
      fill="#D9D9D9"
    />
    <path
      d="M29.1875 32.6875C27.7917 33.4167 21.5357 33.7081 20.25 33.3125C21.9688 34.3125 26.3281 35.4375 29.1875 32.6875Z"
      fill="#187759"
    />
  </svg>
)
